import Footer from './Footer';
import Header from './Header';
import SectionContent from './SectionContent';
import SectionHero from './SectionHero';
import SectionPosts from './SectionPosts';
import Layout from './Layout';

export {
    Footer,
    Header,
    SectionContent,
    SectionHero,
    SectionPosts,
    Layout
};

export default {
    Footer,
    Header,
    SectionContent,
    SectionHero,
    SectionPosts,
    Layout
};
